import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'ff-pdfviewer-modal',
  templateUrl: './pdfviewer-modal.component.html',
  styleUrls: ['./pdfviewer-modal.component.scss']
})
export class PDFViewerModalComponent implements OnInit {

  /**
   * Array of pdf sources to display
   */
  @Input() sources: { url: string, title: string }[] = [];

  /**
   * Object to update the modal's title dynamically
   */
  @Input() title: Subject<string>;

  currentPDF = 0;

  fileExtension = '';

  allowedImageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'];

  constructor() { }

  ngOnInit(): void {
    this.setTitle();
    this.setFileExtension(this.sources[this.currentPDF].title);
  }

  next() {
    if (this.currentPDF < this.sources.length - 1) {
      this.currentPDF++;
      this.setTitle();
      this.setFileExtension(this.sources[this.currentPDF].title);
    }
  }

  prev() {
    if (this.currentPDF > 0) {
      this.currentPDF--;
      this.setTitle();
      this.setFileExtension(this.sources[this.currentPDF].title);
    }
  }

  setTitle() {
    if (this.title)
      this.title.next(this.sources[this.currentPDF].title);
  }

  setFileExtension(title : string){
    this.fileExtension = title.split('.').pop();
  }

}
